@if (tooltipText) {
  <button type="button"
    [class.z-btn-tooltip-icon]="!tooltipIsContainer"
    [class.z-btn-tooltip]="tooltipIsContainer"
    [class.z-btn-tooltip-error]="error"
    [pTooltip]="tooltipText"
    autoHide="false"
    tooltipFocus>
      <span class="sr-only">
        @if (error) { Error! } 
        @else { Tooltip: }
        {{ tooltipText }}
      </span>
      <ng-content></ng-content>
  </button>
}